export default {
	$accessibility: {
		archived: "Archived",
		present: "Present",
	},
	$accessModifier: {
		$description: {
			hidden_from_receiver: "Hidden From Receiver",
			hidden_from_sender: "Hidden From Sender",
			private: "Private",
			shared_with_custom: "Shared with Custom",
			shared_with_everyone: "Shared with Everyone",
			shared_with_receiver: "Shared with Receiver",
			shared_with_sender: "Shared with Sender",
		},
	},
	$antProduct: {
		limitGBStorage: "{limit}GB Storage",
		limitMBStorage: "{limit}MB Storage",
		limitUser: "{limit} User",
		limitUsers: "{limit} Users",
		renewAtPricePerUnit: "Will renew at {currency}{price} per {unit}",
		unlimitedModule: "Unlimited {module}",
		upToLimitModule: "Up to {limit} {module}",
	},
	$company: {
		address: "Kotekli Mah. Denizli Yolu Bul. Teknopark Sitesi B Blok No:4B Ic kapi No:14 MENTESE / MUGLA, TURKEY",
		googleMapSrc:
			"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12715.523446137679!2d28.3731307!3d37.1793022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bf732687fd3eb1%3A0x2815d6eefcce8910!2sMu%C4%9Fla%20Teknopark!5e0!3m2!1sen!2str!4v1701805110461!5m2!1sen!2str",
		name: "Slush Software Inc.",
		phoneNumber: "+90 (555) 444-33-22",
		slogan: "Accelerate your business with Antrego. Manage your shipment processes digitally, safely, and easily.",
	},
	$cookieBanner: {
		accept: "Accept",
		decline: "Decline",
		message:
			"We use cookies and similar technologies for analytics and personalized content. By clicking 'Accept', you consent to our use of these technologies.",
	},
	$country: {
		afghanistan: "Afghanistan",
		aland: "Åland",
		albania: "Albania",
		algeria: "Algeria",
		american_samoa: "American Samoa",
		andorra: "Andorra",
		angola: "Angola",
		anguilla: "Anguilla",
		antarctica: "Antarctica",
		antigua_and_barbuda: "Antigua and Barbuda",
		argentina: "Argentina",
		armenia: "Armenia",
		aruba: "Aruba",
		australia: "Australia",
		austria: "Austria",
		azerbaijan: "Azerbaijan",
		bahamas: "Bahamas",
		bahrain: "Bahrain",
		bangladesh: "Bangladesh",
		barbados: "Barbados",
		belarus: "Belarus",
		belgium: "Belgium",
		belize: "Belize",
		benin: "Benin",
		bermuda: "Bermuda",
		bhutan: "Bhutan",
		bolivia: "Bolivia",
		bonaire_sint_eustatius_and_saba: "Bonaire, Sint Eustatius, and Saba",
		bosnia_and_herzegovina: "Bosnia and Herzegovina",
		botswana: "Botswana",
		bouvet_island: "Bouvet Island",
		brazil: "Brazil",
		british_indian_ocean_territory: "British Indian Ocean Territory",
		british_virgin_islands: "British Virgin Islands",
		brunei: "Brunei",
		bulgaria: "Bulgaria",
		burkina_faso: "Burkina Faso",
		burundi: "Burundi",
		cabo_verde: "Cabo Verde",
		cambodia: "Cambodia",
		cameroon: "Cameroon",
		canada: "Canada",
		cayman_islands: "Cayman Islands",
		central_african_republic: "Central African Republic",
		chad: "Chad",
		chile: "Chile",
		china: "China",
		christmas_island: "Christmas Island",
		cocos_islands: "Cocos [Keeling] Islands",
		colombia: "Colombia",
		comoros: "Comoros",
		congo_republic: "Congo Republic",
		cook_islands: "Cook Islands",
		costa_rica: "Costa Rica",
		croatia: "Croatia",
		cuba: "Cuba",
		curacao: "Curaçao",
		cyprus: "Cyprus",
		czechia: "Czechia",
		denmark: "Denmark",
		djibouti: "Djibouti",
		dominica: "Dominica",
		dominican_republic: "Dominican Republic",
		dr_congo: "Democratic Republic of the Congo",
		ecuador: "Ecuador",
		egypt: "Egypt",
		el_salvador: "El Salvador",
		equatorial_guinea: "Equatorial Guinea",
		eritrea: "Eritrea",
		estonia: "Estonia",
		eswatini: "Eswatini",
		ethiopia: "Ethiopia",
		falkland_islands: "Falkland Islands",
		faroe_islands: "Faroe Islands",
		fiji: "Fiji",
		finland: "Finland",
		france: "France",
		french_guiana: "French Guiana",
		french_polynesia: "French Polynesia",
		french_southern_territories: "French Southern Territories",
		gabon: "Gabon",
		gambia: "Gambia",
		georgia: "Georgia",
		germany: "Germany",
		ghana: "Ghana",
		gibraltar: "Gibraltar",
		greece: "Greece",
		greenland: "Greenland",
		grenada: "Grenada",
		guadeloupe: "Guadeloupe",
		guam: "Guam",
		guatemala: "Guatemala",
		guernsey: "Guernsey",
		guinea: "Guinea",
		guinea_bissau: "Guinea-Bissau",
		guyana: "Guyana",
		haiti: "Haiti",
		heard_island_and_mcdonald_islands: "Heard Island and McDonald Islands",
		honduras: "Honduras",
		hong_kong: "Hong Kong",
		hungary: "Hungary",
		iceland: "Iceland",
		india: "India",
		indonesia: "Indonesia",
		iran: "Iran",
		iraq: "Iraq",
		ireland: "Ireland",
		isle_of_man: "Isle of Man",
		israel: "Israel",
		italy: "Italy",
		ivory_coast: "Ivory Coast",
		jamaica: "Jamaica",
		japan: "Japan",
		jersey: "Jersey",
		jordan: "Jordan",
		kazakhstan: "Kazakhstan",
		kenya: "Kenya",
		kiribati: "Kiribati",
		kosovo: "Kosovo",
		kuwait: "Kuwait",
		kyrgyzstan: "Kyrgyzstan",
		laos: "Laos",
		latvia: "Latvia",
		lebanon: "Lebanon",
		lesotho: "Lesotho",
		liberia: "Liberia",
		libya: "Libya",
		liechtenstein: "Liechtenstein",
		lithuania: "Lithuania",
		luxembourg: "Luxembourg",
		macao: "Macao",
		madagascar: "Madagascar",
		malawi: "Malawi",
		malaysia: "Malaysia",
		maldives: "Maldives",
		mali: "Mali",
		malta: "Malta",
		marshall_islands: "Marshall Islands",
		martinique: "Martinique",
		mauritania: "Mauritania",
		mauritius: "Mauritius",
		mayotte: "Mayotte",
		mexico: "Mexico",
		micronesia: "Micronesia",
		moldova: "Moldova",
		monaco: "Monaco",
		mongolia: "Mongolia",
		montenegro: "Montenegro",
		montserrat: "Montserrat",
		morocco: "Morocco",
		mozambique: "Mozambique",
		myanmar: "Myanmar",
		namibia: "Namibia",
		nauru: "Nauru",
		nepal: "Nepal",
		netherlands: "Netherlands",
		new_caledonia: "New Caledonia",
		new_zealand: "New Zealand",
		nicaragua: "Nicaragua",
		niger: "Niger",
		nigeria: "Nigeria",
		niue: "Niue",
		norfolk_island: "Norfolk Island",
		north_korea: "North Korea",
		north_macedonia: "North Macedonia",
		northern_mariana_islands: "Northern Mariana Islands",
		norway: "Norway",
		oman: "Oman",
		pakistan: "Pakistan",
		palau: "Palau",
		palestine: "Palestine",
		panama: "Panama",
		papua_new_guinea: "Papua New Guinea",
		paraguay: "Paraguay",
		peru: "Peru",
		philippines: "Philippines",
		pitcairn_islands: "Pitcairn Islands",
		poland: "Poland",
		portugal: "Portugal",
		puerto_rico: "Puerto Rico",
		qatar: "Qatar",
		reunion: "Réunion",
		romania: "Romania",
		russia: "Russia",
		rwanda: "Rwanda",
		saint_barthelemy: "Saint Barthélemy",
		saint_helena: "Saint Helena",
		saint_lucia: "Saint Lucia",
		saint_martin: "Saint Martin",
		saint_pierre_and_miquelon: "Saint Pierre and Miquelon",
		samoa: "Samoa",
		san_marino: "San Marino",
		sao_tome_and_principe: "São Tomé and Príncipe",
		saudi_arabia: "Saudi Arabia",
		senegal: "Senegal",
		serbia: "Serbia",
		seychelles: "Seychelles",
		sierra_leone: "Sierra Leone",
		singapore: "Singapore",
		sint_maarten: "Sint Maarten",
		slovakia: "Slovakia",
		slovenia: "Slovenia",
		solomon_islands: "Solomon Islands",
		somalia: "Somalia",
		south_africa: "South Africa",
		south_georgia_and_south_sandwich_islands: "South Georgia and South Sandwich Islands",
		south_korea: "South Korea",
		south_sudan: "South Sudan",
		spain: "Spain",
		sri_lanka: "Sri Lanka",
		st_kitts_and_nevis: "St Kitts and Nevis",
		st_vincent_and_grenadines: "St Vincent and Grenadines",
		sudan: "Sudan",
		suriname: "Suriname",
		svalbard_and_jan_mayen: "Svalbard and Jan Mayen",
		sweden: "Sweden",
		switzerland: "Switzerland",
		syria: "Syria",
		taiwan: "Taiwan",
		tajikistan: "Tajikistan",
		tanzania: "Tanzania",
		thailand: "Thailand",
		timor_leste: "Timor-Leste",
		togo: "Togo",
		tokelau: "Tokelau",
		tonga: "Tonga",
		trinidad_and_tobago: "Trinidad and Tobago",
		tunisia: "Tunisia",
		turkiye: "Turkiye",
		turkmenistan: "Turkmenistan",
		turks_and_caicos_islands: "Turks and Caicos Islands",
		tuvalu: "Tuvalu",
		uganda: "Uganda",
		ukraine: "Ukraine",
		united_arab_emirates: "United Arab Emirates",
		united_kingdom: "United Kingdom",
		united_states: "United States",
		uruguay: "Uruguay",
		us_minor_outlying_islands: "U.S. Minor Outlying Islands",
		us_virgin_islands: "U.S. Virgin Islands",
		uzbekistan: "Uzbekistan",
		vanuatu: "Vanuatu",
		vatican_city: "Vatican City",
		venezuela: "Venezuela",
		vietnam: "Vietnam",
		wallis_and_futuna: "Wallis and Futuna",
		western_sahara: "Western Sahara",
		yemen: "Yemen",
		zambia: "Zambia",
		zimbabwe: "Zimbabwe",
	},
	$currency: {
		euro: "Euro",
		turkish_lira: "Turkish Lira",
		us_dollar: "U.S. Dollar",
	},
	$documentManager: {
		message_1: 'To edit the template, click the "Edit Template" button to access the editing screen.',
		message_2: 'You can change the number of rows in the list by increasing or decreasing the "Row Count."',
		message_3: 'Changes made in the content fields will instantly appear in the "Preview" section.',
		message_4: 'To generate a PDF, click the "Document Actions" button to save it as a PDF.',
		message_5: 'To access documents later, you can save them via the "Document Actions" button.',
		message_6: "The data entered in each cell of the table will be reflected exactly in the preview.",
		message_7: "The data table can be edited like an Excel sheet or an electronic spreadsheet.",
	},
	$employeeType: {
		admin: "Admin",
		default: "Default",
		exporter: "Exporter",
		importer: "Importer",
	},
	$format: {
		date: "MM/DD/YYYY",
		date_time: "MM/DD/YYYY HH:mm:ss",
		date_time_without_second: "MM/DD/YYYY HH:mm",
	},
	$home: {
		$noCompany: {
			create_company_subtitle: "Create your company here.",
			create_company_title: "Do you want to add your company?",
			description: "You have signed in successfully. Now you need to join a company or create a new one.",
			join_company_subtitle: "Enter your code and join the company here.",
			join_company_title: "Do you want to join an existing company?",
			title: "Welcome {name}",
		},
		$unauthorized: {
			description: "Keep your export-import processes under control by using Antrego",
			forget_password_subtitle: "Please enter your email address to reset your password.",
			sign_in_subtitle: "Sign in here",
			sign_in_title: "Do you already have an account?",
			sign_up_subtitle: "Sign up here",
			sign_up_title: "Do you want to create your account?",
			title: "Welcome to Antrego",
		},
	},
	$invitationType: {
		company_partner: "Commercial Cooperation Invitation",
		customs_partner: "Customs Partner Invitation",
		employee: "Employee Invitation",
	},
	$landing: {
		$benefits: {
			$detailPage: {
				benefit_1: "Complete visibility across your entire supply chain",
				benefit_2: "Secure cloud-based platform with enterprise-grade encryption",
				benefit_3: "Mobile-responsive design for on-the-go access",
				benefit_4: "Automated notifications keep all stakeholders informed",
				benefit_5: "Customizable workflows that adapt to your business processes",
				benefit_6: "Dedicated support team to ensure your success",
				benefits_title: "Why Choose Antrego?",
				cta_button: "Start Free Today",
				cta_subtitle: "No credit card required • Join 500+ companies",
				cta_title: "Ready to Transform Your Logistics Operations?",
				feature_1_desc:
					"Access all your logistics data, shipments, inventory, and documents from a single, intuitive interface.",
				feature_1_title: "Centralized Dashboard",
				feature_2_desc:
					"Minimize errors with automated data entry, validation, and real-time synchronization across all modules.",
				feature_2_title: "Enhanced Data Accuracy",
				feature_3_desc: "Save hours daily with automated workflows, smart notifications, and streamlined processes.",
				feature_3_title: "Time Efficiency",
				feature_4_desc:
					"Enable seamless collaboration between internal teams, customers, suppliers, and logistics partners.",
				feature_4_title: "Team Collaboration",
				feature_5_desc:
					"Reduce operational costs through improved efficiency, fewer errors, and optimized resource allocation.",
				feature_5_title: "Cost Reduction",
				feature_6_desc: "Grow your business confidently with a platform that scales effortlessly with your needs.",
				feature_6_title: "Scalability",
				features_title: "Comprehensive Platform Benefits",
				hero_description:
					"Discover how Antrego streamlines your entire logistics workflow, from inventory management to shipment tracking. Experience increased efficiency, reduced costs, and enhanced collaboration across your organization.",
				hero_subtitle: "Platform Benefits",
				hero_title: "Transform Your Business Operations",
				step_1_desc:
					"Bring together inventory management, shipment tracking, document handling, and customer communication in one integrated platform.",
				step_1_title: "Consolidate Your Operations",
				step_2_desc:
					"Let Antrego handle repetitive tasks like data entry, notifications, and status updates, freeing your team for strategic work.",
				step_2_title: "Automate Routine Tasks",
				step_3_desc:
					"Share information instantly with all stakeholders, ensuring everyone has access to the latest updates and documents.",
				step_3_title: "Enable Real-Time Collaboration",
				step_4_desc:
					"Leverage comprehensive analytics and reporting to identify trends, optimize processes, and drive continuous improvement.",
				step_4_title: "Make Data-Driven Decisions",
				workflow_title: "How Antrego Transforms Your Operations",
			},
			benefits_title: "Platform Benefits",
			business_process: "Speeds up your business processes.",
			control_title: "Take control with Antrego.",
			highlight_word: "control",
			risk_of_error: "Reduces the risk of errors.",
			text: "Antrego transforms logistics operations for exporters, importers, freight forwarders, and manufacturers with end-to-end digital solutions for inventory management, real-time shipment tracking, and automated documentation.",
			time_and_cost_savings: "Saves time and costs.",
		},
		$content: {
			$text: {
				0: "Track all your shipments in one place, and control your finances with dynamic reporting.",
				1: "Share your real-time updates with your customers to improve your service quality.",
				2: "View and share all documents related to your shipment in one system.",
				3: "Easily control your process by accessing Antrego from all devices and locations.",
				4: "Store all your data using SHA-256 encryption technology. Rest assured about security.",
				5: "Engage in joint tracking with all stakeholders in the business process. Manage the process more efficiently.",
			},
			$title: {
				0: "End-to-End Shipment Management",
				1: "Real-Time Customer Communication",
				2: "Centralized Document Management",
				3: "Cloud-Based Access Anywhere",
				4: "Enterprise-Grade Security",
				5: "Multi-Party Collaboration",
			},
			content_title: "Everything You Need in One Platform",
		},
		$home: {
			subtitle: "Manage inventory, shipments, documents & tracking in one powerful platform",
			text: "Save 40% of operational time with automated workflows. Join 500+ companies streamlining their logistics operations globally.",
			title: "Complete Logistics Platform: From Stock to Delivery",
		},
		$lifecycle: {
			headline: "Process",
			info_button: "Get Information",
			lifecycle_texts: {
				0: "Upload additional files to create your proforma invoice and instantly share it with your customer.",
				1: "Enter your shipment details and add documents. Notify your customer and jointly manage all shipment processes through a single channel.",
				2: "Track your financial situation related to import and export in real-time.",
			},
			lifecycle_titles: {
				0: "Log In and Create Proforma Invoice",
				1: "Create Shipment",
				2: "Track Financial Activities",
			},
			productivity_title: "Increase productivity and reduce complexity and errors in 3 steps.",
			tracking_guide_title: "Easy Tracking Guide",
		},
		$logistics: {
			logistics_title: "Supported Logistics Types",
			solutions_title: "The right solution for every load",
			text: "With Antrego, your digital partner in all types of transport, we stand by your side for all your global movements.",
		},
		$pdfEditor: {
			description:
				"Our PDF editor is a powerful tool that makes creating and editing invoices more practical. Save time and present professional-looking documents to your business partners.",
			features: {
				design: "Invoice Design: Add your logo, adjust colors, and customize your invoice format.",
				edit: "Document Editing: Quickly edit PDFs, add or remove text.",
				shareSave: "Sharing and Saving: Download, share, or store your created documents directly on the platform.",
			},
			longTitle: "Fast and Personalized Invoices with the PDF Editor.",
			note: "This setup allows users to visually explore features and review advantages in writing.",
			title: "Creating Invoices is So Easy!",
			$detailPage: {
				hero_title: "Professional PDF Document Creation",
				hero_subtitle: "Create stunning commercial documents in minutes",
				hero_description:
					"Antrego's intuitive PDF creator empowers you to design, customize, and generate professional invoices, proforma invoices, and commercial documents with ease. No design skills required.",
				features_title: "Everything You Need to Create Professional Documents",
				feature_1_title: "Drag & Drop Editor",
				feature_1_desc:
					"Intuitive interface lets you add text, images, logos, and tables with simple drag-and-drop actions. No technical skills needed.",
				feature_2_title: "Custom Templates",
				feature_2_desc:
					"Choose from pre-designed templates or create your own branded layouts. Save templates for consistent branding across all documents.",
				feature_3_title: "Smart Form Fields",
				feature_3_desc:
					"Automatically populate customer information, product details, and pricing. Connect directly with your shipment and stock data.",
				feature_4_title: "Brand Customization",
				feature_4_desc:
					"Add your company logo, choose brand colors, customize fonts, and create documents that perfectly represent your business identity.",
				feature_5_title: "Multi-Format Export",
				feature_5_desc:
					"Download as PDF, print directly, or share via email. All documents are professionally formatted and print-ready.",
				feature_6_title: "Version Control",
				feature_6_desc:
					"Track document revisions, maintain history, and access previous versions. Never lose important document iterations.",
				benefits_title: "Why Choose Antrego PDF Creator?",
				benefit_1: "Create professional documents 10x faster than traditional methods",
				benefit_2: "Maintain consistent branding across all your commercial documents",
				benefit_3: "Reduce errors with automated data population from your shipments",
				benefit_4: "Save time with reusable templates and smart forms",
				benefit_5: "Impress clients with polished, professional-looking documents",
				benefit_6: "Access your documents anywhere, anytime from any device",
				workflow_title: "How PDF Creation Works",
				step_1_title: "Choose Template",
				step_1_desc:
					"Select from pre-designed templates or start with a blank canvas to create your custom document layout.",
				step_2_title: "Customize Content",
				step_2_desc:
					"Drag and drop elements, add your logo and branding, populate fields with shipment data automatically.",
				step_3_title: "Preview & Edit",
				step_3_desc:
					"Review your document in real-time, make adjustments, and ensure everything looks perfect before generating.",
				step_4_title: "Generate & Share",
				step_4_desc:
					"Download as PDF, email directly to customers, or attach to shipments. Save template for future use.",
				cta_title: "Start creating professional documents today",
				cta_button: "Get Started Free",
				cta_subtitle: "No credit card required • Start creating in minutes",
			},
		},
		$process: {
			comparison_subtitle: "See the difference between traditional and digital logistics management",
			digital_future: "Move away from traditional methods and step into the digital future",
			digital_shipping: "Digital Shipment Tracking with Antrego",
			digital_shipping_texts: {
				0: "Proforma invoices for incoming orders are created and tracked easily through a single channel.",
				1: "Proforma invoices are sent, notifications go to the customer instantly, and they are approved through Antrego.",
				2: "Document processes are managed through Antrego. They are not lost, no delays occur, and the potential for errors is minimized.",
				3: "Suppliers, customers, and customs brokers can instantly see shipment details and track them jointly.",
				4: "Financial reports are automatically generated monthly and annually.",
			},
			question_title: "How Antrego Saves You 10+ Hours Per Week",
			tracking_method: "Digitize your tracking methods and speed up your processes.",
			traditional_shipping: "Traditional Shipment Tracking",
			traditional_shipping_texts: {
				0: "Orders are collected via email, messages, or phone through different channels, causing internal tracking difficulties.",
				1: "The proforma invoice is created using tools like Excel, and the approval process is manually handled through email, WhatsApp, or phone.",
				2: "Manual document processes lead to errors and delays, causing time and financial losses.",
				3: "There is no common platform for suppliers, customers, and customs brokers to track shipment details.",
				4: "Financial data is checked individually after each shipment, making reporting difficult.",
			},
		},
		$question: {
			$text: {
				0: "<p>Antrego is a comprehensive logistics management platform that helps companies track shipments, manage inventory, and collaborate with customers in real-time. It digitizes your entire supply chain process from stock to delivery.</p>",
				1: "<p>Antrego simplifies logistics with Easy Access from any device, enterprise-grade Data Security using SHA-256 encryption, and Joint Tracking that keeps all stakeholders informed throughout the shipment process.</p>",
				2: "<p>Antrego supports all major transportation modes including Sea freight, Air cargo, Land transport, and Rail logistics. We work with all major carriers and shipping lines worldwide.</p>",
				3: "<p>Antrego offers a free plan for up to 10 shipments per month with no credit card required. Premium plans start at $99/month for unlimited shipments, with annual billing saving you 16%. See our pricing page for full details.</p>",
				4: "<p>We're currently developing API access and integration capabilities with popular logistics and ERP systems. Integration features are planned for future releases. Contact us to learn more about our roadmap and upcoming features.</p>",
				5: "<p>Most companies are up and running within 24 hours. Basic setup takes just 5-10 minutes to create your account and add company information. Our onboarding team helps you import data and customize workflows.</p>",
			},
			$title: {
				0: "What is Antrego?",
				1: "Why should I use Antrego?",
				2: "What types of logistics does Antrego support?",
				3: "How much does Antrego cost?",
				4: "Can I integrate Antrego with my existing systems?",
				5: "How long does it take to set up Antrego?",
			},
			save_percentage: "Save 16% Monthly",
			text: "Easily access all information with Antrego, and feel free to contact us for any other questions you may have.",
			title: "Quickly Learn Whatever You're Curious About",
		},
		$stockFeature: {
			$detailPage: {
				benefit_1: "Increase visibility of your products to global buyers",
				benefit_2: "Reduce time spent on manual inventory tracking",
				benefit_3: "Streamline the transition from stock to sales",
				benefit_4: "Provide real-time stock information to customers",
				benefit_5: "Support for 15+ languages to reach international markets",
				benefit_6: "Integrated with shipment and invoicing systems",
				benefits_title: "Why Choose Antrego for Stock Management?",
				cta_button: "Get Started Free",
				cta_subtitle: "No credit card required • Set up in minutes",
				cta_title: "Ready to modernize your inventory management?",
				feature_1_desc:
					"Manage all your stock items from a single dashboard. Track quantities, lot numbers, warehouses, and product details with ease.",
				feature_1_title: "Centralized Inventory Management",
				feature_2_desc:
					"Create a public catalog page to showcase your available products to potential customers worldwide. Share your inventory with a simple link.",
				feature_2_title: "Public Stock Catalog",
				feature_3_desc:
					"Track individual stock batches with detailed information including quantities, dimensions, and custom attributes for precise inventory management.",
				feature_3_title: "Batch Tracking",
				feature_4_desc:
					"Organize your inventory across multiple warehouses and locations. Keep track of where each product is stored for efficient logistics.",
				feature_4_title: "Multi-Warehouse Support",
				feature_5_desc:
					"Upload multiple images for each stock item to provide visual clarity to your customers and team members.",
				feature_5_title: "Product Image Gallery",
				feature_6_desc:
					"Seamlessly convert stock items into shipments. Create proforma invoices and shipment documents directly from your inventory.",
				feature_6_title: "Direct to Shipment",
				features_title: "Powerful Stock Management Features",
				hero_description:
					"Antrego's Stock Management feature empowers exporters and manufacturers to efficiently manage inventory, share product catalogs with customers, and accelerate the sales process through a single integrated platform.",
				hero_subtitle: "From inventory to sales - manage your entire product lifecycle digitally",
				hero_title: "Transform Your Stock Management",
				step_1_desc:
					"Create stock items with detailed information including product details, quantities, warehouses, and images.",
				step_1_title: "Add Your Products",
				step_2_desc:
					"Generate a public link to your stock catalog that potential customers can view and browse at any time.",
				step_2_title: "Share Your Catalog",
				step_3_desc: "Customers can view your available products and contact you directly for orders and quotes.",
				step_3_title: "Receive Inquiries",
				step_4_desc: "Easily create proforma invoices and shipments from your stock items to fulfill customer orders.",
				step_4_title: "Convert to Sales",
				workflow_title: "How It Works",
			},
			access_potential_customers: "Quickly reach potential customers",
			desc: "Specially designed for exporters and manufacturers, Antrego accelerates your sales and marketing processes. Grow your business with stock management, customer stock sharing, and shipment management!",
			global_market: "Take your place in the global market with support for 15 different languages",
			main_title: "The next-generation solution for sales and marketing",
			manage_stocks: "Manage and share your stocks instantly",
			speed_up_sales: "Speed up sales processes",
			title: "From Stock to Sales",
		},
		$tracking: {
			$detailPage: {
				benefit_1: "Reduce customer inquiries with self-service tracking access",
				benefit_2: "Prevent costly delays with proactive monitoring and alerts",
				benefit_3: "Improve customer satisfaction with transparent communication",
				benefit_4: "Save time with automated status updates to all stakeholders",
				benefit_5: "Minimize risks with real-time visibility into shipment status",
				benefit_6: "Professional tracking pages that enhance your brand image",
				benefits_title: "Why Choose Antrego Tracking?",
				cta_button: "Get Started Free",
				cta_subtitle: "No credit card required • Start tracking today",
				cta_title: "Start tracking your shipments with confidence",
				feature_1_desc:
					"Track your containers in real-time with precise location updates and estimated arrival times for every shipment.",
				feature_1_title: "Live Container Tracking",
				feature_2_desc:
					"Receive instant alerts for important milestones: loading, departure, arrival, customs clearance, and delivery status.",
				feature_2_title: "Automated Notifications",
				feature_3_desc:
					"Access complete shipment history with detailed logs of all movements, status changes, and key events.",
				feature_3_title: "Status History",
				feature_4_desc:
					"Share tracking information with customers, suppliers, and customs brokers. Everyone stays informed automatically.",
				feature_4_title: "Multi-Stakeholder Visibility",
				feature_5_desc:
					"Attach and access all shipment documents including bills of lading, customs forms, and certificates in one place.",
				feature_5_title: "Document Management",
				feature_6_desc:
					"Get proactive notifications about potential delays or issues so you can take action before problems escalate.",
				feature_6_title: "Delay Alerts",
				features_title: "Complete Tracking Solution",
				hero_description:
					"Antrego's advanced tracking system provides complete visibility into your shipments with real-time updates, automated notifications, and comprehensive status reports. Never lose track of your containers again.",
				hero_subtitle: "Monitor every container, every step of the way",
				hero_title: "Real-Time Shipment Tracking",
				step_1_desc: "Enter shipment details including container numbers, routes, and expected dates into the system.",
				step_1_title: "Create Shipment",
				step_2_desc: "System automatically tracks containers and updates status as they move through each checkpoint.",
				step_2_title: "Automated Updates",
				step_3_desc: "All parties receive instant notifications about important milestones and status changes.",
				step_3_title: "Stakeholder Notifications",
				step_4_desc: "Get final delivery confirmation with complete documentation and shipment history records.",
				step_4_title: "Delivery Confirmation",
				workflow_title: "How Tracking Works",
			},
			control_title: "Take control of your shipments with Antrego.",
			real_time_alerts:
				"Real-Time Alerts: Receive instant notifications and comprehensive status updates for every container.",
			secure_data_handling:
				"Secure Data Handling: Easily download, share, or store your shipment data directly on the platform.",
			tracking_description:
				"Antrego’s container tracking solution offers a fast and efficient way to monitor your shipments in real time. Stay in control and impress your partners with detailed, professional updates.",
			tracking_title: "Track Your Shipments With Ease!",
		},
		cancel_anytime: "Cancel anytime",
		customize_package:
			"You can purchase additional storage and users and customize your package according to your needs",
		free_features_1: "10 Shipments",
		free_features_2: "100 MB Storage",
		free_features_3: "Unlimited Commercial Partners",
		free_features_4: "1 User",
		free_plan: "Free",
		free_price: "$0",
		free_regeneration: "",
		free_title: "Monthly",
		pdfEditor: {
			$detailPage: {
				hero_title: "Professional PDF Document Creation",
				hero_subtitle: "Create stunning commercial documents in minutes",
				hero_description:
					"Antrego's intuitive PDF creator empowers you to design, customize, and generate professional invoices, proforma invoices, and commercial documents with ease. No design skills required.",
				features_title: "Everything You Need to Create Professional Documents",
				feature_1_title: "Drag & Drop Editor",
				feature_1_desc:
					"Intuitive interface lets you add text, images, logos, and tables with simple drag-and-drop actions. No technical skills needed.",
				feature_2_title: "Custom Templates",
				feature_2_desc:
					"Choose from pre-designed templates or create your own branded layouts. Save templates for consistent branding across all documents.",
				feature_3_title: "Smart Form Fields",
				feature_3_desc:
					"Automatically populate customer information, product details, and pricing. Connect directly with your shipment and stock data.",
				feature_4_title: "Brand Customization",
				feature_4_desc:
					"Add your company logo, choose brand colors, customize fonts, and create documents that perfectly represent your business identity.",
				feature_5_title: "Multi-Format Export",
				feature_5_desc:
					"Download as PDF, print directly, or share via email. All documents are professionally formatted and print-ready.",
				feature_6_title: "Version Control",
				feature_6_desc:
					"Track document revisions, maintain history, and access previous versions. Never lose important document iterations.",
				benefits_title: "Why Choose Antrego PDF Creator?",
				benefit_1: "Create professional documents 10x faster than traditional methods",
				benefit_2: "Maintain consistent branding across all your commercial documents",
				benefit_3: "Reduce errors with automated data population from your shipments",
				benefit_4: "Save time with reusable templates and smart forms",
				benefit_5: "Impress clients with polished, professional-looking documents",
				benefit_6: "Access your documents anywhere, anytime from any device",
				workflow_title: "How PDF Creation Works",
				step_1_title: "Choose Template",
				step_1_desc:
					"Select from pre-designed templates or start with a blank canvas to create your custom document layout.",
				step_2_title: "Customize Content",
				step_2_desc:
					"Drag and drop elements, add your logo and branding, populate fields with shipment data automatically.",
				step_3_title: "Preview & Edit",
				step_3_desc:
					"Review your document in real-time, make adjustments, and ensure everything looks perfect before generating.",
				step_4_title: "Generate & Share",
				step_4_desc:
					"Download as PDF, email directly to customers, or attach to shipments. Save template for future use.",
				cta_title: "Start creating professional documents today",
				cta_button: "Get Started Free",
				cta_subtitle: "No credit card required • Start creating in minutes",
			},
		},
		premium_annual_features_1: "20 Users",
		premium_annual_features_2: "100 Partners",
		premium_annual_features_3: "1000 Shipments",
		premium_annual_features_4: "1000 Invoices",
		premium_annual_price: "$83.25",
		premium_annual_regeneration: "Will renew annually at $999",
		premium_annual_title: "Annual",
		premium_monthly_features_1: "Unlimited Shipments",
		premium_monthly_features_2: "Unlimited Commercial Partners",
		premium_monthly_features_3: "2GB Storage",
		premium_monthly_features_4: "3 Users",
		premium_monthly_price: "$99",
		premium_monthly_regeneration: "Will renew monthly at $99",
		premium_monthly_title: "Monthly",
		premium_plan: "Premium Plan",
		premium_plus_annual_features_1: "Unlimited Shipments",
		premium_plus_annual_features_2: "Unlimited Commercial Partners",
		premium_plus_annual_features_3: "5GB Storage",
		premium_plus_annual_features_4: "5 Users",
		premium_plus_annual_price: "$83.25",
		premium_plus_annual_regeneration: "Will renew annually at $999",
		premium_plus_annual_title: "Annual",
		premium_plus_monthly_features_1: "Unlimited Shipments",
		premium_plus_monthly_features_2: "Unlimited Commercial Partners",
		premium_plus_monthly_features_3: "5GB Storage",
		premium_plus_monthly_features_4: "5 Users",
		premium_plus_monthly_price: "$249",
		premium_plus_monthly_regeneration: "Will renew monthly at $249",
		premium_plus_monthly_title: "Monthly",
		premium_plus_plan: "Premium Plus",
		pricing_text: "We can meet your needs in the best way without breaking your budget.",
		pricing_title: "Antrego guarantees to offer the best package and price for you.",
		save_percentage: "Save 16% Monthly",
	},
	$language: {
		ar: "العربية",
		de: "Deutsch",
		en: "English",
		es: "Español",
		fr: "Français",
		hi: "हिन्दी",
		ind: "Bahasa Indonesia",
		it: "Italiano",
		ja: "日本語",
		ko: "한국어",
		pt: "Português",
		ru: "Русский",
		tr: "Türkçe",
		vi: "Tiếng Việt",
		zh: "中文",
	},
	$languageLocal: {
		ar: "Arabic",
		de: "German",
		en: "English",
		es: "Spanish",
		fr: "French",
		hi: "Hindi",
		ind: "Indonesian",
		it: "Italian",
		ja: "Japanese",
		ko: "Korean",
		pt: "Portuguese",
		ru: "Russian",
		tr: "Turkish",
		vi: "Vietnamese",
		zh: "Chinese",
	},
	$message: {
		cannot_delete_verified_partner: "You cannot delete a verified partner.",
		confirm: "Are you sure to {function}?",
		created: "{item} created.",
		deleted: "{item} deleted.",
		edited: "{item} edited.",
		error_on_view_file: "An error occurred while viewing the file.",
		file_oversize: "File size must be maximum {size}.",
		invalid: "Invalid {item}",
		migrated: "{item} migrated. ({value})",
		process_has_been_started: "Your {item} has been started.",
		saved: "{item} saved.",
		sent: "{item} sent.",
		sent_email: "E-mail sent. ({value})",
		sign_in_failed: "E-mail or password is incorrect",
		unsupported_file_type: "Unsupported file type",
		updated: "{item} updated.",
	},
	$pageDescriptions: {
		landing_page:
			"Antrego - Complete logistics management platform for exporters, importers & freight forwarders. Track shipments in real-time, manage inventory, create invoices & automate documentation. Save 40% time with digital logistics solutions. Try free!",
		stock_feature:
			"Transform your stock management with Antrego. Manage inventory, create public catalogs, track batches across warehouses, and convert stock to shipments instantly. Perfect for exporters and manufacturers.",
		tracking_feature:
			"Real-time container and shipment tracking with Antrego. Monitor every container with live updates, automated notifications, complete status history, and multi-stakeholder visibility. Never lose track of your shipments.",
		pdf_feature:
			"Professional PDF document creator for logistics. Design custom invoices and proforma invoices with drag-and-drop editor, templates, and automated data population. Create stunning documents in minutes.",
		benefits_feature:
			"Discover Antrego platform benefits. Centralized dashboard, enhanced accuracy, time efficiency, team collaboration, cost reduction, and scalability. Transform your logistics operations today.",
		contact:
			"Contact Antrego - Get in touch with our team for questions, demos, or support. We're here to help transform your logistics operations.",
		sign_in:
			"Sign in to Antrego - Access your logistics dashboard to manage shipments, track containers, create invoices, and collaborate with your team. Secure login portal.",
		sign_up:
			"Sign up for Antrego - Create your free account to start managing logistics operations. Get 10 free shipments per month. No credit card required to start.",
	},
	$pageTitles: {
		accept_invitation: "Accept Invitation",
		company_profile: "Company Profile",
		home: "Home",
		landing_page: "Easily Manage All Your Shipping Processes Digitally",
		partners: "Partners",
		pdf_editor: "PDF Editor",
		product_details: "Product Details",
		product_groups: "Product Groups",
		products: "Products",
		proforma_invoices: "Proforma Invoices",
		shipment_details: "Shipment Details",
		shipments: "Shipments",
		sign_in: "Sign In",
		sign_up: "Sign Up",
		stock_details: "Stock Details",
		stocks: "Stocks",
		subscription: "Subscription",
		user_profile: "User Profile",
		stock_feature: "Stock Management - Transform Your Inventory",
		tracking_feature: "Shipment Tracking - Real-Time Container Monitoring",
		pdf_feature: "PDF Document Creator - Professional Invoices",
		benefits_feature: "Platform Benefits - Complete Logistics Solution",
		contact: "Contact Us - Get in Touch with Antrego",
	},
	$partnershipStatusTooltip: {
		createdHereDescription:
			"Not registered partners, you created their profile on our platform, so you can view and edit their information.",
		createdHereTitle: "Created Here:",
		description: "You can track the status of your relation with your partners. Here are the differences:",
		verifiedPartnersDescription:
			"These partners have accepted your invitation and registered on the platform. Their information is view-only and cannot be edited.",
		verifiedPartnersTitle: "Verified Partners:",
	},
	$productGroup: {
		add_child: "Add Child",
		add_new_product_group: "Add New Product Group",
		add_to_root: "Add to Root",
		has_children_fail_message: "A product group with a child can not be deleted",
		initial_message: "Use this {0} button to create your first product group.",
		name: "Name",
		number_of_product: "Number of Product",
	},
	$proformaInvoice: {
		$actionDescription: {
			approve: "{name} approved.",
			create: "Created by {name}.",
			create_attachment: "{name} created an attachment.",
			delete_attachment: "{name} deleted an attachment.",
			demand_revise: "{name} demanded revise.",
			mark_as_processed: "{name} marked as processed.",
			reject: "{name} rejected.",
			revoke: "{name} revoked.",
			send: "{name} sent to receiver for assessment.",
			update: "Updated by {name}.",
			update_attachment: "{name} updated an attachment.",
		},
		$actions: {
			approve: "Approve",
			demand_revise: "Demand Revise",
			mark_as_approved: "Approved",
			mark_as_processed: "Processed",
			mark_as_rejected: "Rejected",
			mark_as_revise_demanded: "Revise Demanded",
			mark_as_revoked: "Revoked",
			mark_as_sent: "Sent",
			reject: "Reject",
			revoke: "Revoke",
			send: "Send",
		},
		$status: {
			approved: "Approved",
			pending_approval: "Pending Approval",
			pending_revise: "Pending Revise",
			processed: "Processed",
			rejected: "Rejected",
			revoked: "Revoked",
			template: "Template",
		},
		approve_confirm_message: "Are you sure to approve the proforma invoice?",
		approve_success_message: "The proforma invoice has been approved.",
		demand_revise_description_message: "Please give some detail about your revision expectation:",
		demand_revise_success_message: "The proforma invoice has been sent back to the sender for revise.",
		mark_as_processed_confirm_message: "Do you confirm to mark the proforma invoice as processed?",
		mark_as_processed_success_message: "The proforma invoice has been marked as processed.",
		no_attachment_text: "No attachment added yet.",
		reject_confirm_message: "Are you sure to reject the proforma invoice?",
		reject_success_message: "The proforma invoice has been rejected.",
		revoke_confirm_message: "Are you sure to revoke the proforma invoice?",
		revoke_success_message: "The proforma invoice has been revoked.",
		send_confirm_message: "Do you confirm to send the proforma invoice to the receiver?",
		send_success_message: "The proforma invoice has been sent.",
	},
	$seoTitles: {
		landing_page: "Antrego | Logistics Management Software - Track, Manage, Automate",
		stock_feature: "Inventory Management Software | Stock Tracking System | Antrego",
		tracking_feature: "Real-Time Shipment Tracking Software | Container Tracking | Antrego",
		pdf_feature: "Proforma Invoice Generator | PDF Editor for Logistics | Antrego",
		benefits_feature: "Complete Logistics Platform Benefits | All-in-One Solution | Antrego",
	},
	$serviceMessage: {
		already_subs_module: "There's already a subscription for this module.",
		bad_request: "Bad Request",
		code_already_used: "Code has already been used.",
		container_status_not_available: "Container status is not available.",
		existing_email_warning: "E-mail already exist.",
		existing_employee_error: "This user is already added to your company.",
		existing_employee_for_email_warning: "Invitation code has already been sent to this e-mail",
		existing_invitation_warning: "Invitation code has already been sent to this e-mail.",
		existing_token_already_have_time: "Existing token already have enough time to be used.",
		existing_user: "User already exist.",
		five_min_reset_password_mail: "You must wait 5 minutes at least after you request a password reset e-mail once.",
		forbidden: "Forbidden",
		have_no_corporation: "You have no corporation",
		have_no_custom_agency: "You have no customs agency",
		have_no_employee: "You have no employee",
		instance_can_no_delete_existing_booking_code: "The instance can no longer be deleted due to existing booking code.",
		instance_cannot_delete: "The instance can no longer be deleted.",
		instance_not_found: "Instance not found.",
		internal_server_error: "Internal Server Error",
		invalid_current_password: "Invalid current password.",
		invalid_identifier_or_password: "Invalid identifier or password",
		invalid_invitation_code: "The invite code is incorrect.",
		invalid_moving_request: "Invalid moving request",
		invalid_operation: "Invalid operation",
		invalid_refresh_token: "Invalid refresh token.",
		invalid_unit: "Invalid unit",
		invitation_accepting_is_due_to_the_admin: "Invitation accepting is due to the admin.",
		invitation_already_discarded: "The invitation has already been discarded.",
		invitation_already_used: "The invitation has already been used.",
		invitation_has_been_used: "The invitation has been used.",
		invitation_not_exist_email: "Invitation does not exist email address.",
		invitation_not_for_company: "This invitation is not for a company.",
		invitation_not_for_custom_agency: "This invitation is not for a custom agency.",
		invitation_not_found: "The invitation not found.",
		invitation_not_valid: "The invitation is not valid anymore.",
		link_has_been_expired: "Link has been expired.",
		link_not_be_used_anymore: "This link may not be used anymore",
		missing_required_fields: "Missing required fields.",
		no_employee_found: "No employee found",
		no_proper_partner_found: "No proper partner found.",
		not_acceptable: "Not Acceptable",
		not_allowed_action: "You are not allowed for this action.",
		not_allowed_use_api: "You are not allowed to use this api.",
		not_found: "Not Found",
		not_have_purchase_subscription:
			"Your subscription plan has reached the maximum limit for definitions. To add more, please consider upgrading your subscription plan.",
		not_permitted_use_api: "You are not permitted to use this api.",
		own_invitation_cannot_accept: "You can not accept your own invitation.",
		parent_group_not_found: "Parent Group not found",
		partnerId_required: "Partner ID is required.",
		partnership_already_exists: "The partner has already been added.",
		password_cant_involve_space_char: "Password can not involve space char.",
		password_min_chars_least: "Password must be 6 chars at least.",
		payment_required: "Please subscribe for this process.",
		paytr_integration_error:
			"There was a problem with the payment infrastructure. It will be fixed as soon as possible.",
		ports_are_required: "Ports are required.",
		product_group_tree_not_found: "Product Group Tree not found",
		proforma_invoice_action_not_available: "The status of proforma invoice is not available for this action.",
		proforma_invoice_template_update: "Proforma invoice must be template to be updated.",
		shipment_email_not_exist: "Please enter valid e-mail.",
		shipment_method_is_required: "Shipping method is required.",
		shipping_term_is_required: "Shipping term is required.",
		someone_else_uses_this_email: "Someone else uses this email address.",
		someone_else_uses_this_username: "Someone else uses this username.",
		something_went_wrong: "Something went wrong",
		type_can_be_abstract_company: '"type" property can just be "abstract_company"',
		unauthorized: "Unauthorized",
		undefined_result: "Undefined result",
		unexpected_error_occurred: "Unexpected error occurred",
		unit_already_added: "Unit has already been added.",
		user_already_employee: "The user is already is an employee.",
		user_already_exists: "User already exists in a company.",
		user_does_not_exist: "User does not exist.",
		user_not_found: "User not found.",
		username_min_chars_error: '"username" must be 6 chars at least.',
	},
	$shipment: {
		$actionDescription: {
			$land: {
				create_container: "{name} added a vehicle.",
				delete_container: "{name} deleted a vehicle.",
				update_container: "{name} updated a vehicle.",
			},
			create: "Created by {name}.",
			create_attachment: "{name} added an attachment.",
			create_container: "{name} added a container.",
			delete_attachment: "{name} deleted an attachment.",
			delete_container: "{name} deleted a container.",
			update: "Updated by {name}.",
			update_attachment: "{name} updated an attachment.",
			update_container: "{name} updated a container.",
		},
		$containerStatus: {
			arrived: "Arrived",
			off_load: "Off Load",
			on_load: "On Load",
			on_way: "On The Way",
			reserved: "Reserved",
		},
		$method: {
			aerial: "Aerial",
			land: "Land",
			railway: "Railway",
			sea: "Sea",
		},
		$vehicle: {
			license_number: "License Plate",
		},
		archiving_success_message: "Shipment has been archived.",
		leave_message: "Leave your message or comment",
		no_booking_info: "No booking info has been set yet. Use {0} button to add.",
		no_transportation_info: "No detail info has been set yet. Use {0} button to set.",
		un_archiving_success_message: "Shipment has been un-archived.",
	},
	$shortening: {
		number: "No",
	},
	$socialMedia: {
		facebook: "Facebook",
		instagram: "Instagram",
		linked_in: "LinkedIn",
		twitter: "Twitter",
	},
	$subscription: {
		$message: {
			check_your_payment_method: "Your subscription could not be renewed. Please check your payment method.",
			fail: "Unexpected error occurred. Please try again later. If the problem persists, please report it by sending an e-mail to info@antrego.net.",
			ok: "The purchasing process has been initiated. The result of the process will be notified by e-mail. Your subscription will be started when the payment is completed successfully.",
			payment_process_is_ongoing:
				"Your payment process is ongoing. The result of the process will be notified by e-mail. Your subscription will be started when the payment is completed successfully.",
			success: "Your subscription has been successfully created. You can start using Antrego easily.",
			try_to_get_paid_again: "Your subscription has expired. Click here to renew.",
			unsubscribed: "Unsubscribed",
			you_dont_have_any_subscription:
				"You do not have any subscriptions. Please choose a package on the subscription page and start using it easily.",
			you_dont_have_any_subscription_text:
				"Choose the membership plan best for you and take full advantage of the opportunities.",
			you_dont_have_any_subscription_title: "Do More with our Plans",
		},
	},
	$unit: {
		acres: "Acres",
		boxes: "Boxes",
		centimeter: "Centimeter",
		cubic_meter: "Cubic Meter",
		dozen: "Dozen",
		feet: "Feet",
		fluid_ounces: "Fluid Ounces",
		gallons: "Gallons",
		gram: "Gram",
		hectare: "Hectare",
		inches: "Inches",
		kilogram: "Kilogram",
		kilometer: "Kilometer",
		liter: "Liter",
		meter: "Meter",
		miles: "Miles",
		milligram: "Milligram",
		milliliter: "Milliliter",
		millimeter: "Millimeter",
		ounces: "Ounces",
		pallets: "Pallets",
		pieces: "Pieces",
		pounds: "Pounds",
		quarts: "Quarts",
		square_feet: "Square Feet",
		square_inches: "Square Inches",
		square_kilometer: "Square Kilometer",
		square_meter: "Square Meter",
		square_miles: "Square Miles",
		square_yards: "Square Yards",
		ton: "Tons",
		yards: "Yards",
	},
	$validation: {
		email: "Please enter valid e-mail",
		invalid: "Invalid {item}",
		max_length: "{item} must be less than {length} characters",
		min_length: "{item} must be more than {length} characters",
		must_length: "{item} must be {length} characters",
		only_number: "{item} should be a number",
		password_repeat_warning: "Password repeat is not same as new password.",
		required: "{item} is required",
		required_for_default_language: "{item} is required for the company's default language.",
		you_must_approve_distance_sales_agreement: "You must approve the Distance Sales Contract",
	},
	about: "About",
	accept_invitation: "Accept Invitation",
	accept_invitation_success_message: "You've used the invitation successfully.",
	accessibility: "accessibility",
	actions: "Actions",
	active: "Active",
	activities: "Activities",
	add: "Add",
	add_attribute: "Add Attribute",
	add_from_stock: "Add From Stock",
	add_images: "Add Image",
	add_item: "Add {item}",
	add_manually: "Create Here",
	add_new_employee: "Add New Employee",
	add_new_packaging: "Add New Packaging",
	add_new_product: "Add New Product",
	add_new_stock: "Add New Stock",
	add_new_warehouse: "Add New Warehouse",
	add_stock_batch: "Add Stock Batch",
	add_template: "Add Template",
	add_variant: "Add Variant",
	address: "Address",
	again: "Again",
	alert: "Alert",
	already_have_employee_message: "You are already an employee of a company.",
	amount: "Amount",
	approve: "Approve",
	archive: "Archive",
	attachment: "Attachment",
	attachments: "Attachments",
	attribute: "Attribute",
	attributes: "Attributes",
	auto_attached_pdf: "Automatically Attached PDF",
	auto_detect: "Auto Detect",
	available: "Available",
	bank: "Bank",
	basket: "Basket",
	basket_empty: "Your basket is empty",
	batch: "Batch",
	batch_no: "Batch No",
	batches: "Stock Batches",
	benefits: "Benefits",
	benefits_feature: "Platform Benefits",
	billed_to: "Billed to",
	booking: "Booking",
	booking_code: "Booking Code",
	booking_details: "Booking Details",
	boolean: "Boolean",
	business_partner: "Business Partner",
	business_partners: "Business Partners",
	cancel: "Cancel",
	carrier: "Carrier",
	change_password: "Change Password",
	checking_invitation_code_message: "Checking invitation code",
	checkout: "Checkout",
	choose_image: "Choose image",
	choose_your_plan: "Choose Your Plan",
	clear: "Clear",
	clear_basket: "Clear Basket",
	click_to_play_the_video: "Click to play the video",
	close: "Close",
	code: "Code",
	commercial: "Commercial",
	commercial_partner: "Commercial Partner",
	commercial_partners: "Commercial Partners",
	companies: "Companies",
	company: "Company",
	company_address: "Company Address",
	company_name: "Company Name",
	company_profile: "Company Profile",
	configuration: "Configuration",
	confirm: "Confirm",
	confirm_distance_selling_agreement: "Confirm the Distance Sales Contract.",
	consult_us: "Consult Us",
	contact: "Contact",
	contact_info: "Contact Information",
	contact_text: "Rest assured, we will reach out to you as soon as possible.",
	contact_title: "Consult Us, Simplify Your Processes",
	contact_to_us: "Contact Us",
	container: "Container",
	container_no: "Container No",
	containers: "Containers",
	content: "Content",
	contract: "Contract",
	copy_link: "Copy Link",
	corporation: "Company",
	countries: "Countries",
	country: "Country",
	create: "Create",
	create_a_new_account: "Create a New Account",
	create_company: "Create Company",
	create_document: "Create Document",
	create_shipment: "Create Shipment",
	created_at: "Created At",
	created_here: "Created Here",
	credit_card_info: "Credit Card Info",
	credit_card_no: "Credit Card No.",
	currencies: "Currencies",
	currency: "Currency",
	current_password: "Current Password",
	current_plan: "Current Plan",
	customer_company_address: "Customer Company Address",
	customer_company_name: "Customer Company Name",
	customs: "Customs",
	customs_agencies: "Customs Agencies",
	customs_agency: "Customs Agency",
	cvv: "CVV",
	daily: "Daily",
	damaged: "Damaged",
	dashboard: "Dashboard",
	date: "Date",
	date_input: "Date Input",
	day: "Day",
	default: "Default",
	default_language: "Default Language",
	delete: "Delete",
	delete_account: "Delete Account",
	delete_confirm_message: "Do you confirm the delete?",
	delete_document: "Delete Document",
	delete_template: "Delete Template",
	description: "Description",
	detail: "Detail",
	dimensions: "Dimensions",
	discard: "Discard",
	discover_all_benefits: "Discover All Benefits",
	distance_sales_agreement: "The Distance Sales Contract",
	document: "Document",
	document_actions: "Document Actions",
	document_added: "Document Added",
	document_creator: "Document Creator",
	document_manager: "Document Manager",
	document_name: "Document Name",
	document_number: "Document No",
	document_overwrite: "Save edits as new document",
	document_save_info: "This document will only be saved inside this proforma invoice.",
	document_updated: "Document Updated",
	download: "Download",
	download_pdf: "Download PDF",
	download_template: "Download Template",
	edit: "Edit",
	edit_attribute: "Edit Attribute",
	edit_description: "Edit Description",
	edit_document: "Edit Document",
	edit_item: "Edit {item}",
	edit_packaging: "Edit Packaging",
	edit_product: "Edit Product",
	edit_profile: "Edit Profile",
	edit_stock: "Edit Stock",
	edit_stock_batch: "Edit Stock Batch",
	edit_template: "Edit template",
	edit_variant: "Edit Variant",
	edit_your_profile_picture: "Edit your profile picture",
	email: "E-mail",
	employee: "Employee",
	employee_type: "Employee Type",
	employees: "Employees",
	empty_data_warning: "There is no data in this area yet. You can start exploring the platform with sample data.",
	estimated_arrival_day: "Estimated Arrival Day",
	expense: "Expense",
	expenses: "Expenses",
	expires_at: "Expires At",
	explore_pdf_editor: "Create Documents Instantly",
	explore_stock_management: "Master Your Inventory",
	explore_tracking_features: "Track in Real-Time",
	exported_containers: "Exported Containers",
	fail: "Fail",
	failed: "Failed",
	faq: "F.A.Q.",
	feedback: "Feedback",
	file: "File",
	file_name: "File Name",
	file_preview: "File Preview",
	file_processing_error_message: "Error processing file: {error}",
	file_read_error_message: "Error reading file",
	file_view: "View File",
	filter: "Filter",
	first_name: "First Name",
	first_name_last_name: "First Name Last Name",
	fixed_value: "Fixed Value",
	forget_password: "Forget Password",
	forget_password_message: "Did you forget your password?",
	forget_password_subtitle: "Please enter your email address to reset your password.",
	format: "Format",
	free: "Free",
	from: "From",
	general: "Default",
	get_started_now: "Get Started Now",
	give_us_feedback: "Give Us Feedback",
	go_to_panel: "Go To Panel",
	go_to_proforma: "Go to Proforma",
	go_to_shipment: "Go to Shipment",
	gross: "Gross",
	height: "Height",
	hide: "Hide",
	hide_all: "Hide All",
	home_page: "Home Page",
	i_have_invitation_code: "I have an invitation code",
	image_delete: "Delete Image",
	images: "Images",
	import_excel: "Import from Excel",
	import_fail_message: "Import failed: {error}",
	import_success_message: "Successfully imported {count} products{skipped}.",
	imported_containers: "Imported Containers",
	in_progress: "In Progress",
	in_stock: "In Stock",
	incoming: "Incoming",
	incoming_shipments: "Incoming Shipments",
	initial: "Initial",
	inputs: "Inputs",
	invitation: "Invitation",
	invitation_code: "Invitation Code",
	invitation_mail_sent: "Invitation email sent",
	invitations: "Invitations",
	invoice: "Invoice",
	invoice_no: "Invoice Number",
	join: "Join",
	join_company: "Join Company",
	language: "Language",
	language_options: "Language Options",
	last_name: "Last Name",
	last_one_year: "Last 1 Year",
	latitude: "Latitude",
	learn_more: "Learn More",
	left_a_comment: "Left a Comment",
	length: "Length",
	link_copied: "Link copied",
	link_copy_failed: "Link copy failed",
	loading_country: "Loading Country",
	loading_point: "Loading Point",
	loading_port: "Loading Port",
	log_in: "Log In",
	logo: "Logo",
	longitude: "Longitude",
	lot_no: "Lot No",
	mail_sent: "E-mail sent",
	make_visible: "Make Visible",
	manage_profile: "Manage Your Antrego Profile",
	mass: "Mass",
	measurements: "Measurements",
	merge_partner_description:
		"The company created here can be merged with the existing verified partner when it creates a profile on Antrego.",
	message: "Message",
	message_company_create: "Company created.",
	message_company_join: "Please enter the invitation code.",
	message_company_joined: "You joined to company",
	message_employee_delete: "Employee deleted.",
	message_employee_save: "Employee saved.",
	message_join_company: "Enter your code for join existing company",
	method: "Method",
	migrate: "Migrate",
	migrate_partner: "Migrate Company",
	migrate_partner_description:
		"The company created here can be merged with the existing verified partner when it creates a profile on Antrego",
	missing_product_group_sheet_message: "Missing Product Group sheet in Excel file",
	missing_product_sheet_message: "Missing Product sheet in Excel file",
	mobile_number: "Mobile Number",
	month: "Month",
	month_lowercase: "month",
	monthly: "Monthly",
	multiple_select: "Multiple Select",
	my_profile: "My Profile",
	my_role: "My Role",
	name: "Name",
	net: "Net",
	new: "New",
	new_company_package: "Free",
	new_password: "New Password",
	new_shipment: "New Shipment",
	next: "Next",
	no: "No",
	no_content: "No Content",
	no_entity: "No {entityName} yet",
	no_entity_message: "Created {entityName} and its details will be listed here",
	no_image: "No Image Found",
	no_product_data_message: "No product data found in Excel file",
	no_product_group_data_message: "No product group data found in Excel file",
	no_stock_batches_found: "No Stock Batch Found",
	no_stock_matches_filters: "There is no stock matching the selected filters.",
	no_stocks_added_yet: "No stocks have been added yet — please select or add one.",
	no_text: "No Text",
	no_valid_products_message:
		"No valid products found. All products must have a name in the default language ({language}).",
	not_found_in_stock: "Couldn't find a product in stock with current filters.",
	not_found_page_message: "Sorry, I could not find this page :(",
	not_set: "Not Set",
	note: "Note",
	notes: "Notes",
	number_of_rows: "Number of Rows",
	ok: "OK",
	operation_fail: "Operation Fail",
	option: "Option",
	options: "Options",
	other: "Other",
	out_of_stock: "Out Of Stock",
	outgoing: "Outgoing",
	outgoing_shipments: "Outgoing Shipments",
	packages: "Packages",
	packaging: "Packaging",
	packing_list_title: "Packing List",
	pageDescriptions: {
		landing_page:
			"Antrego - Complete logistics management platform for exporters, importers & freight forwarders. Track shipments in real-time, manage inventory, create invoices & automate documentation. Save 40% time with digital logistics solutions. Try free!",
		stock_feature:
			"Transform your stock management with Antrego. Manage inventory, create public catalogs, track batches across warehouses, and convert stock to shipments instantly. Perfect for exporters and manufacturers.",
		tracking_feature:
			"Real-time container and shipment tracking with Antrego. Monitor every container with live updates, automated notifications, complete status history, and multi-stakeholder visibility. Never lose track of your shipments.",
		pdf_feature:
			"Professional PDF document creator for logistics. Design custom invoices and proforma invoices with drag-and-drop editor, templates, and automated data population. Create stunning documents in minutes.",
		benefits_feature:
			"Discover Antrego platform benefits. Centralized dashboard, enhanced accuracy, time efficiency, team collaboration, cost reduction, and scalability. Transform your logistics operations today.",
		contact:
			"Contact Antrego - Get in touch with our team for questions, demos, or support. We're here to help transform your logistics operations.",
		sign_in:
			"Sign in to Antrego - Access your logistics dashboard to manage shipments, track containers, create invoices, and collaborate with your team. Secure login portal.",
		sign_up:
			"Sign up for Antrego - Create your free account to start managing logistics operations. Get 10 free shipments per month. No credit card required to start.",
	},
	pageTitles: {
		stock_feature: "Stock Management - Transform Your Inventory",
		tracking_feature: "Shipment Tracking - Real-Time Container Monitoring",
		pdf_feature: "PDF Document Creator - Professional Invoices",
		benefits_feature: "Platform Benefits - Complete Logistics Solution",
		contact: "Contact Us - Get in Touch with Antrego",
	},
	parent_group: "Parent Group",
	partner: "Partner",
	partners: "Partners",
	partnership_status: "Partnership Status",
	passive: "Passive",
	password: "Password",
	pay: "Pay",
	payback: "Payback",
	payback_confirm_message: "Do you confirm the payback?",
	payback_warning_message: "If you continue, your subscription will be terminated.",
	payment: "Payment",
	payment_amount: "Payment Amount",
	payment_awaited: "Payment Awaited",
	payment_history: "Payment History",
	payment_info: "Payment Info",
	payment_information: "Payment Information",
	payment_success: "Payment Success",
	payment_summary: "Payment Summary",
	payment_will_be_made_3d_secure: "*Your payment will be made with 3d Secure.",
	pdf_attached_message: "PDF Successfully Attached",
	pdf_editor: "PDF Editor",
	pdf_feature: "PDF Document Creator",
	pdf_name: "PDF name",
	pending_invitations: "Pending Invitations",
	per_month: "per month",
	phone_number: "Phone Number",
	pieces: "Pieces",
	plate_numbers: "Plate Numbers",
	please_click_add_option: "You have typed an option but didn’t add it. Please add or clear it.",
	prefix: "Prefix",
	premium: "Premium",
	premium_plus: "Premium Plus",
	preview: "Preview",
	previous: "Previous",
	price: "Price",
	pricing: "Pricing",
	process: "Process",
	product: "Product",
	product_details: "Product Details",
	product_group: "Product Group",
	product_group_name: "Product Group Name",
	product_group_not_found_message: 'Product group "{group}" not found. Skipping product with code "{code}".',
	product_groups: "Product Groups",
	product_images: "Product Images",
	product_name: "Product Name",
	products: "Products",
	profile: "Profile",
	proforma_invoice: "Proforma Invoice",
	proforma_invoices: "Proforma Invoices",
	proforma_number: "Proforma No",
	proforma_options: "Proforma Options",
	proforma_title: "Proforma Invoice",
	purchase: "Purchase",
	quantity: "Quantity",
	quantity_warning:
		"Since you previously changed the Stock Total value, the total will not be calculated automatically.",
	ready_to_import: "Ready to import",
	receiver: "Receiver",
	receiver_company: "Receiver Company",
	receiver_customs_agency: "Receiver Customs Agency",
	redirection_to_home_link: "Home",
	redirection_to_home_message: "You can also go to ",
	redirection_to_sign_in_message: "Do you have an account?",
	redirection_to_sign_up_message: "Don't you have an account yet?",
	reload: "Reload",
	renewal: "Renewal",
	repaid: "Repaid",
	reserved: "Reserved",
	reset_password: "Reset Password",
	returned: "Returned",
	route: "route",
	rows_per_page: "Rows per page",
	sales: "Sales",
	save: "Save",
	save_as_document: "Save as Document",
	save_as_new_document: "Save as New Document",
	save_as_new_template: "Save as New Template",
	save_as_template: "Save as Template",
	save_changes: "Save Changes",
	save_pdf_to_attachments: "Save PDF to Attachments",
	saved_card_info: "Saved Card Info",
	search: "Search",
	select: "Select",
	select_a_file_to_preview: "Select a file to preview",
	select_document: "Select the Document",
	select_document_to_overwrite: "Select Document to Overwrite",
	select_file: "Select File",
	select_file_place_holder: "Please select an image",
	select_language: "Select language",
	select_template: "Select the Template",
	select_template_to_overwrite: "Select Template to Overwrite",
	selected: "Selected",
	selected_partner: "Selected Partner",
	send: "Send",
	send_again: "Send Again",
	send_email: "Send E-mail",
	send_feedback: "Send Feedback",
	send_invitation: "Send Invitation",
	sender: "Sender",
	sender_company: "Sender Company",
	sender_customs_agency: "Sender Customs Agency",
	separate_gross: "Add Gross Measurements",
	settings: "Settings",
	shipment: "Shipment",
	shipment_code: "Shipment Code",
	shipment_details: "Shipment Details",
	shipment_method: "Shipment Method",
	shipment_type: "Shipment Type",
	shipments: "Shipments",
	shipments_filter: "Shipments Filter",
	shipped: "Shipped",
	shipping_term: "Shipping Term",
	shipping_terms: "Shipping Terms",
	show: "Show",
	show_all: "Show All",
	show_company_stock_page: "Show Company Stock Page",
	show_in_stocks: "Show on Stock Page",
	sign_in: "Sign In",
	sign_out: "Sign Out",
	sign_out_confirm_message: "Do you confirm signing out?",
	sign_out_success_message: "Good Bye.",
	sign_up: "Sign Up",
	sizes: "Sizes",
	social_media: "Social Media",
	social_media_account: "Social Media Account",
	start_time: "Start Time",
	status: "Status",
	stock: "Stock",
	stock_details: "Stock Details",
	stock_images: "Stock Images",
	stock_status: "Stock Status",
	stocks: "Stocks",
	stocks_url: "Stock Link",
	subscribe: "Subscribe",
	subscription: "Subscription",
	subscription_info_message: "You can benefit from all services unlimitedly during the subscription period.",
	subscription_warning_message:
		"**Your card information will be securely stored and your subscription will be renewed regularly unless you cancel it.",
	success: "Success",
	super: "Super",
	supported_files_img: "Supported file types: JPG, PNG files under 20 mb",
	switch_language: "Switch Language",
	switch_theme: "Switch Theme",
	table_inputs: "Table Inputs",
	target: "Target",
	target_partner: "Target Partner",
	tax_number: "Tax Number",
	template: "Template",
	template_actions: "Template Actions",
	template_added: "Template Added",
	template_name: "Template Name",
	template_overwrite: "Save edits as new template",
	template_save_info: "Saved templates will later be available for use in proforma invoices and shipments.",
	template_updated: "Template Updated",
	terms_of_sale_and_other_comments: "Terms of Sale - Comments",
	text_input: "Text Input",
	theme: "Theme",
	this_month: "This Month",
	this_year: "This Year",
	title: "Title",
	to: "To",
	toDelete: "Delete",
	total: "Total",
	total_amount: "Total Amount",
	total_price: "Total Price",
	total_warning: "If you change this data, the total will no longer be calculated automatically.",
	tracking: "Shipment Tracking",
	transaction_no: "Transaction No",
	transactions: "Transactions",
	try_for_free: "Try for Free",
	type: "Type",
	types: "Types",
	un_archive: "Un-archive",
	unit: "Unit",
	unit_price: "Unit Price",
	units: "Units",
	unloading_country: "Unloading Country",
	unloading_point: "Unloading Point",
	unloading_port: "Unloading Port",
	unsubscribe: "Unsubscribe",
	unsubscribe_confirm_message:
		"If you unsubscribe, you will not be able to use the system features effectively. Are you sure you want to unsubscribe?",
	upload_new_image: "Upload New Image",
	use_code: "Use Code",
	use_invitation_code: "Use Invitation Code",
	use_invitation_code_description: "Type your invitation code that sent your mailbox.",
	use_invitation_code_success_message: "Invitation code has been used successfully.",
	user_profile: "My Profile",
	value: "Value",
	variant: "Variant",
	variants: "Variants",
	vehicle: "Vehicle",
	vehicles: "Vehicles",
	verified_partner: "Verified Partner",
	verify_password: "Verify Password",
	visibility: "Visibility",
	warehouse: "Warehouse",
	warehouses: "Warehouses",
	warn_unsaved_measurement: "Don’t forget to click ‘+’ to add your measurements.",
	website: "Website",
	week: "Week",
	weight: "Weight",
	weight_kg: "Weight (kg)",
	welcome: "Welcome",
	what_we_are_doing: "What We Are Doing",
	width: "Width",
	year: "Year",
	year_lowercase: "year",
	yearly: "Yearly",
	yes: "Yes",
	yes_no: "Yes / No",
	you_dont_have_any_active_subscription: "You don't have any active subscription",
};
